@switch (loadingStatus) {
  @case (RequestStatus.loading) {
    <div class="grid-ui-loading-container">
      <grid-ui-loading></grid-ui-loading>
    </div>
  }
  @case (RequestStatus.error) {
    <div class="grid-ui-error-container">
      <grid-ui-error
        [errorCode]="error?.errorCode"
        [errorMessage]="error?.errorMessage"
        [errorPrimaryAction]="error?.errorPrimaryAction"
        [errorSecondaryAction]="error?.errorSecondaryAction"
        [showContact]="error?.showContact"
        [contactEmail]="error?.contactEmail"
        (primaryActionClick)="setServiceOfferings()"
        (secondaryActionClick)="reloadApp()"
      >
      </grid-ui-error>
    </div>
  }
  @case (RequestStatus.loaded) {
    <div class="Home__content layout-grow overflow-auto">
      <div class="Home__header">
        <div class="Home__logo">
          <img class="Home__vm" [src]="'vm-logo-tm.svg' | mcImageUrl" alt="Verisk Maplecroft" />
          <h1 class="Home__title">GlobalRisk <span class="Home__title-light">Dashboard</span></h1>
        </div>

        <div class="IndexCatalogue">
          <h2 class="IndexCatalogue__title">Index Catalogue</h2>

          <div class="IndexCatalogue__body">
            <p class="IndexCatalogue__description">
              The <b>Index Catalogue</b> provides detailed information about each of Verisk Maplecroft's indices
            </p>

            <a
              class="btn mc-btn-primary IndexCatalogue__download"
              download
              rel="noopener noreferrer"
              data-hook="index-catalogue-download-link"
              [href]="indexCatalogueDownloadURL"
              data-testid="link-download-index-catalogue"
            >
              Download Index Catalogue (.xlsx)
            </a>
          </div>
        </div>
      </div>

      <div class="Home__service-offerings">
        @for (serviceOffering of permittedServiceOfferings; track serviceOffering.key ?? serviceOffering.elementId) {
          <mc-home-service-offering-card
            class="Home__service-offering"
            (navClick)="navigate($event)"
            [serviceOffering]="serviceOffering"
            [imageHref]="serviceOffering.imageHref"
            [attr.data-testid]="'card-' + serviceOffering.label | slugify"
          >
          </mc-home-service-offering-card>
        }
      </div>
    </div>

    <footer class="Home__footer">
      <div class="Home__footer-inner">
        <img class="Home__footer-icon" [src]="'verified_user.png' | mcImageUrl | assetsPath" alt="Verified User" />
        <p class="Home__footer-text">
          Maplecroft has completed a SOC 2® Type 1 examination for the GRiD platform and is Cyber Essentials certified.
          <a
            href="https://www.maplecroft.com/data/global-risk-dashboard/security/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="link-security-compliance"
            >Learn more.</a
          >
        </p>
        <img class="Home__footer-icon" [src]="'certified.png' | mcImageUrl | assetsPath" alt="Cyber Essentials Certified" />
      </div>
    </footer>
  }
}
